import { Injectable } from '@angular/core';
import { Http, Headers, Response, RequestOptions } from '@angular/http'
import 'rxjs/add/operator/toPromise'
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map'

import { SeguridadService } from '../_services/seguridad.service'

import { AppSettings } from '../_models/settings.models'

@Injectable()

export class MenuService{

  constructor(private http: Http,
              private seguridad: SeguridadService
            ){

  }

  getMenu(){
    let headers = new Headers({ 'Content-Type': 'application/json' });
    let options = new RequestOptions({ headers: headers});

    let userToken : string = localStorage.getItem('currentUserToken');

    return this.http.post(AppSettings.API_URL, JSON.stringify({ tokenid: userToken, action: "userGetMenu", api_keytoken: AppSettings.API_KEYTOKEN }))
        .map((response: Response) => {

            if (!this.seguridad.getError(response)){ //si no hay error

              return response;
            }

        });
  }

}



// WEBPACK FOOTER //
// ./src/app/_services/menu.service.ts